import { initAccordion, initTextFillAnimation } from '../parts/helpers';
import { initializeHistorySliders, initializeGoalsSliders } from '../parts/sliders';

const initBlockAccordionSections = () => {
  // Initialize accordion
  initAccordion();

  // Initialize text fill animation
  initTextFillAnimation();

  let initSLiders = true;

  window.addEventListener('scroll', () => {
    
    if (!initSLiders) return;

    // Initialize history slider
    initializeHistorySliders(); 
      
    // Initialize goals slider
    initializeGoalsSliders();

    initSLiders = false;
  });

};

document.addEventListener('DOMContentLoaded', initBlockAccordionSections, false)